import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { check } from '@/api/auth';

Vue.use(VueRouter);

interface Meta {
  isNoAuth: boolean;
}

const noAuthMeta: Meta = {
  isNoAuth: true,
};

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/app',
  },
  {
    path: '/test',
    component: () => import('@/views/Data.vue'),
    meta: noAuthMeta,
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: noAuthMeta,
    props: (route) => ({ isSp: route.query.sp === '1' }),
  },
  {
    path: '/regist',
    component: () => import('../views/Regist.vue'),
    meta: noAuthMeta,
  },
  {
    path: '/activate',
    name: 'activate',
    component: () => import('../views/Activate.vue'),
    meta: noAuthMeta,
    props: true,
  },
  {
    path: '/app',
    component: () => import('../views/App.vue'),
    children: [
      {
        path: 'top',
        component: () => import('../views/Top.vue'),
      },
      {
        path: 'search',
        component: () => import('../views/Search.vue'),
      },
      {
        path: 'view/:id',
        component: () => import('@/views/Data.vue'),
        props: true,
      },
      {
        path: 'manage',
        component: () => import('@/views/Manage.vue'),
      },
      {
        path: 'measure',
        component: () => import('@/views/Measure.vue'),
      },
      {
        path: 'setting',
        component: () => import('@/views/Setting.vue'),
      },
      {
        path: '/',
        redirect: 'search',
      },
    ],
  },
  {
    path: '/view/:id',
    component: () => import('@/views/Data.vue'),
    props: true,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const meta = to.meta as Meta;

  if (meta.isNoAuth) {
    return next();
  }

  const ret = await check();

  if (!ret.success) {
    return next({ path: '/login', params: { error: 'unauth' } });
  }
  return next();
});

export default router;
